export enum RhombusCameraSnapshotStatus {
  Unassigned = 'Unassigned',
  Healthy = 'Healthy',
  Warning = 'Warning',
  Unhealthy = 'Unhealthy',
}

export const SnapshotError = {
  CameraOffline: 'CameraOffline',
  SnapshotFailed: 'SnapshotFailed',
} as const;

export interface CameraSnapshotStatusOption {
  label: string;
  value: RhombusCameraSnapshotStatus;
}

export const CAMERA_SNAPSHOT_DETAILS_STATUS_OPTIONS: CameraSnapshotStatusOption[] = [
  { label: 'Healthy', value: RhombusCameraSnapshotStatus.Healthy },
  { label: 'Warning', value: RhombusCameraSnapshotStatus.Warning },
  { label: 'Unhealthy', value: RhombusCameraSnapshotStatus.Unhealthy },
];

export const CAMERA_SNAPSHOT_STATUS_OPTIONS: CameraSnapshotStatusOption[] = [
  { label: 'Unassigned', value: RhombusCameraSnapshotStatus.Unassigned },
  ...CAMERA_SNAPSHOT_DETAILS_STATUS_OPTIONS,
];

export interface LocationSnapshotResponse {
  location_id: number;
  location_name: string;
  branch_id: number;
  branch_name: string;
  cameras: SnapshotCameraResponse[];
  snapshot_requests: SnapshotRequestResponse[];
  schedules: SnapshotScheduleResponse[];
}

export interface SnapshotCameraResponse {
  location_camera_id: string;
  provider_branch_id: string;
  provider_camera_id: string;
  camera_name: string;
  has_region_of_interest: boolean;
}

export interface SnapshotRequestResponse {
  id: string;
  request_date_time: string;
  snapshots: SnapshotItemResponse[];
  status: RhombusCameraSnapshotStatus;
  comments?: string;
  score: number | null;
}

export interface SnapshotItemResponse {
  url: string | null;
  location_camera_id: string;
  snapshot_error?: string;
}

export interface SnapshotScheduleResponse {
  id?: string;
  time: string;
}

export interface SnapshotScheduleRequest {
  id?: string;
  time: string;
}

export interface UpdateSnapshotSchedulesRequest {
  schedules: SnapshotScheduleRequest[];
}

export interface CameraSnapshotRequest {
  location_camera_id: string;
  provider_branch_id: string;
  provider_camera_id: string;
}

export interface GetCameraSnapshotsRequest {
  cameras: CameraSnapshotRequest[];
  request_date_time: string;
}

export interface SnapshotUpdateRequest {
  status: RhombusCameraSnapshotStatus;
  comments?: string;
}
